import { render } from "./Teleport.vue?vue&type=template&id=8f5dd396"
import script from "./Teleport.vue?vue&type=script&lang=js"
export * from "./Teleport.vue?vue&type=script&lang=js"
script.render = render

export default script